export default {
  closeSpotlightSearch: 'esc',
  closeTestSet: 'alt+w',
  closeInspect: 'esc',
  closeAddToDictionary: 'esc',
  openInspect: 'enter',
  runAction: 'enter',
  excludeLine: 'space',
  createNew: 'alt+n',
  saveNew: 'alt+s',
  runAnnotator: 'alt+r',
  spotlightSearch: 'alt+j',
  moveUp: 'up',
  moveDown: 'down',
  goToLine: 'alt+l',
  // searchOnFile: 'alt+f',
  moveLineUp: {
    windows: 'alt+ctrl+up',
    mac: 'alt+command+up',
  },
  moveLineDown: {
    windows: 'alt+ctrl+down',
    mac: 'alt+command+down',
  },
  // editorSave: 'alt+s',
  openEditorSearch: 'alt+f',
  toggleGoToLine: 'alt+l',
  duplicateLine: 'alt+d',
  editorDeleteLine: {
    windows: 'ctrl+backspace',
    mac: 'command+backspace',
  },
  bookmarkLine: 'shift+alt+[',
  nextBookmark: 'alt+[',
  previousBookmark: 'alt+]',
  commentLine: 'alt+/',
};
